import React from "react";
import { useLocation } from "react-router-dom";
import { MobileMenu } from "./mobileMenu";
import { BottomNav } from "./bottomNav";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const Header: React.FC = () => {
  const location = useLocation();
  const cartItems = useSelector((state: RootState) => state.cart.items);
  const uniqueItemsCount = cartItems.length;
  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <header
        style={{ fontFamily: "Cormorant Infant, serif" }}
        className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-sm"
      >
        <div className="lg:max-w-6xl mx-auto px-4 py-4">
          <nav className="flex items-center justify-between">
            <div className="hidden lg:flex space-x-6">
              <a
                href="/gallery"
                className={`text-[14px] font-medium ${
                  isActive("/gallery") ? "text-[#B87775]" : ""
                }`}
              >
                GALLERY
              </a>
              <a
                href="/reviews"
                className={`text-[14px] font-medium ${
                  isActive("/reviews") ? "text-[#B87775]" : ""
                }`}
              >
                REVIEWS
              </a>
              {/* <a
                href="/shop"
                className={`text-[14px] font-medium ${
                  isActive("/shop") ? "text-[#B87775]" : ""
                }`}
              >
                SHOP
              </a> */}
              <a
                href="/our-story"
                className={`text-[14px] font-medium ${
                  isActive("/our-story") ? "text-[#B87775]" : ""
                }`}
              >
                OUR STORY
              </a>
              <a
                href="/privacy-policy"
                className={`uppercase text-[14px] font-medium ${
                  isActive("/privacy-policy") ? "text-[#B87775]" : ""
                }`}
              >
                Privacy Policy
              </a>
            </div>

            <div className="lg:hidden">
              <MobileMenu />
            </div>

            <a href="/" className="absolute left-1/2 -translate-x-1/2">
              <img src="/images/logo.svg" alt="Logo" className="" />
            </a>

            <div className="flex items-center gap-8">
              {/* <a href="/cart" className="relative">
                <img
                  src="/images/cart.svg"
                  alt="Shopping cart"
                  className="h-6 w-6"
                />
                {uniqueItemsCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-[#B87775] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                    {uniqueItemsCount}
                  </span>
                )}
              </a> */}
              <a
                href="/booking"
                className="hidden lg:block bg-[#B87775] text-[14px] text-white py-3 rounded-md hover:bg-[#9a7676] transition-colors text-center w-[175px]"
              >
                BOOK A SESSION
              </a>
            </div>
          </nav>
        </div>
      </header>
      <BottomNav />
    </>
  );
};

export default Header;
